<template>
  <b-overlay :show="overlay" rounded="sm">
    <b-row>
      <b-col cols="12">
        <h4 class="text-primary">
          <feather-icon icon="PlusSquareIcon" size="20" />
          Add new product
        </h4>

        <b-row>
          <b-media class="my-2 col-12">
            <validation-observer ref="refFormObserver">
              <b-card class="">
                <b-row>
                  <h4 class="text-primary col-12">Information</h4>
                  <b-col cols="12" md="6">
                    <template>
                      <p class="mb-1">Product picture</p>
                      <b-avatar
                        ref="previewEl"
                        :src="base64ImageSrc"
                        class="cursor-pointer mb-1"
                        rounded
                        size="150px"
                        @click.native="$refs.refInputEl.click()"
                      >
                        <feather-icon
                          v-if="base64ImageSrc === null"
                          icon="PlusSquareIcon"
                          size="100"
                        />
                      </b-avatar>
                    </template>
                    <b-button
                      class="mt-2 mb-sm-0 mr-2 col-12 col-md-5 d-none"
                      variant="warning"
                      @click="$refs.refInputEl.click()"
                    >
                      <input
                        ref="refInputEl"
                        accept=".jpg,.jpeg,.png,.svg"
                        class="d-none"
                        type="file"
                        @input="setCover($event)"
                      />
                    </b-button>
                  </b-col>
                  <b-col cols="12" md="6">
                    <template>
                      <p class="mb-1">Product Sidebar Picture</p>
                      <b-avatar
                        ref="previewEl"
                        :src="base64ImageSrcSidebar"
                        class="cursor-pointer mb-1"
                        rounded
                        size="150px"
                        @click.native="$refs.refInputElSidebar.click()"
                      >
                        <feather-icon
                          v-if="base64ImageSrcSidebar === null"
                          icon="PlusSquareIcon"
                          size="100"
                        />
                      </b-avatar>
                    </template>
                    <b-button
                      class="mt-2 mb-sm-0 mr-2 col-12 col-md-5 d-none"
                      variant="warning"
                      @click="$refs.refInputElSidebar.click()"
                    >
                      <input
                        ref="refInputElSidebar"
                        accept=".jpg,.jpeg,.png,.svg"
                        class="d-none"
                        type="file"
                        @input="setCoverSidebar($event)"
                      />
                    </b-button>
                  </b-col>

                  <b-col cols="12" md="6">
                    <language-picker
                      @getLanguage="setLanguageId"
                    ></language-picker>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group class="mb-2" label="Name" label-for="name">
                      <validation-provider
                        #default="{ errors }"
                        rules="required"
                      >
                        <b-form-input
                          id="name"
                          v-model="product.name"
                          :state="errors.length > 0 ? false : null"
                        ></b-form-input>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group
                      class="mb-2"
                      label="SubTitle"
                      label-for="subTitle"
                    >
                      <b-form-input
                        id="subTitle"
                        v-model="product.subTitle"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group
                      label="Choose Product Category"
                      label-for="blog-category"
                    >
                      <v-select
                        v-if="categories"
                        id="blog-category"
                        v-model="product.productCategoryId"
                        :options="categories"
                        :reduce="(category) => category.id"
                        label="name"
                        placeholder="Choose your desired category"
                      >
                        <template #no-options
                          >There is no category available</template
                        >
                      </v-select>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group
                      class="mb-2"
                      label="Price"
                      label-for="priceValue"
                    >
                      <validation-provider
                        #default="{ errors }"
                        rules="required"
                      >
                        <b-form-input
                          id="priceValue"
                          v-model="product.priceValue"
                          :state="errors.length > 0 ? false : null"
                        ></b-form-input>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group
                      class="mb-2"
                      label="Discounted price"
                      label-for="discountedPriceValue"
                    >
                      <validation-provider #default="{ errors }">
                        <b-form-input
                          id="discountedPriceValue"
                          v-model="product.discountedPriceValue"
                          :state="errors.length > 0 ? false : null"
                        ></b-form-input>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group
                      class="mb-2"
                      label="Min Order"
                      label-for="minOrder"
                    >
                      <validation-provider
                        #default="{ errors }"
                        rules="required"
                      >
                        <b-form-input
                          id="minOrder"
                          v-model="product.minOrder"
                          :state="errors.length > 0 ? false : null"
                        ></b-form-input>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group
                      label="Choose Product Shipments"
                      label-for="shipments"
                    >
                      <v-select
                        v-if="shipments"
                        id="shipments"
                        v-model="product.shipments"
                        :multiple="true"
                        :options="shipments"
                        :reduce="(shipment) => shipment.id"
                        label="name"
                        placeholder="Choose your desired shipments"
                      >
                        <template #no-options
                          >There is no shipments available</template
                        >
                      </v-select>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group
                      class="mb-2"
                      label="Short Description"
                      label-for="shortDescription"
                    >
                      <validation-provider
                        #default="{ errors }"
                        rules="required"
                      >
                        <b-form-textarea
                          id="shortDescription"
                          v-model="product.shortDescription"
                          :state="errors.length > 0 ? false : null"
                          maxlength="5000"
                        ></b-form-textarea>
                        <span>{{ product.shortDescription.length }}</span>
                        <span> / 5000 Characters</span>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="12">
                    <b-form-group class="mb-2" label="Full Description">
                      <ckEditorMain
                        ref="editorContent"
                        :defaultContent="product.fullDescription"
                        @getEditorContent="setEditorContent"
                      ></ckEditorMain>
                    </b-form-group>
                  </b-col>
                  `
                </b-row>
              </b-card>

              <b-card>
                <b-row>
                  <h4 class="text-primary col-12 mb-2">Properties</h4>

                  <b-col
                    v-for="(property, idx) in product.properties"
                    :key="idx"
                    cols="12"
                  >
                    <ProductCategoryProperty
                      :CPG="CPG"
                      :idx="idx"
                      :product="product"
                      :property="property"
                    />
                  </b-col>
                  <b-col cols="12">
                    <b-button
                      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                      class="col-12 col-md-2"
                      variant="success"
                      @click="addProperty"
                    >
                      + Add property
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>

              <b-card>
                <b-row>
                  <h4 class="text-primary col-12 mb-2">Trailer</h4>
                  <b-col cols="12" md="3">
                    <video
                      v-if="base64Trailer"
                      :src="base64Trailer"
                      controls
                      crossorigin
                      playsinline
                      style="max-height: 30rem"
                    ></video>
                    <b-button
                      class="mt-2 col-6"
                      variant="warning"
                      @click="$refs.refInputEl2.click()"
                    >
                      <input
                        ref="refInputEl2"
                        accept=".webm,.mp4,.ogg"
                        class="d-none"
                        type="file"
                        @change="setVideo"
                      />
                      <span class="">Add video</span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>

              <b-card>
                <div
                  class="mb-1 w-100 d-flex align-items-center justify-content-between"
                >
                  <h1>Seo</h1>
                </div>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form @submit.prevent>
                      <b-form-group label="Seo title" label-for="seoTitle">
                        <b-form-input
                          id="seoTitle"
                          trim
                          placeholder=""
                          v-model="product.seoTitle"
                        />
                      </b-form-group>
                    </b-form>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form @submit.prevent>
                      <b-form-group label="Seo Url" label-for="seoUrl">
                        <b-form-input
                          id="seoUrl"
                          placeholder=""
                          trim
                          v-on:focus="$event.target.select()"
                          v-model="allCharactersToDash"
                        />
                      </b-form-group>
                    </b-form>
                  </b-col>
                  <b-col cols="12">
                    <b-form @submit.prevent>
                      <b-form-group
                        label="Seo Description"
                        label-for="seoDescription"
                      >
                        <b-form-textarea
                          id="seoDescription"
                          trim
                          placeholder=""
                          v-model="product.seoDescription"
                        />
                      </b-form-group>
                    </b-form>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <!--- serp Desktop --->
                    <div
                      class="serp-preview d-lg-flex p-3 d-none flex-column align-items-start"
                    >
                      <div class="serp-title">
                        <h4 style="color: rgb(26, 13, 171) !important">
                          {{ product.seoTitle }}
                        </h4>
                      </div>
                      <div class="serp-url">
                        <!--              <span class="serp-arrow"></span>-->
                        <h5
                          class="d-flex align-items-center flex-wrap"
                          style="color: rgb(0, 102, 33) !important"
                        >
                          <span>
                            {{
                              `https://ariaexport.com${
                                langs[product.languageId]
                              }/products/`
                            }}
                          </span>
                          <span style="overflow-wrap: anywhere">{{
                            allCharactersToDash
                          }}</span>
                        </h5>
                      </div>
                      <div class="serp-description">
                        <h6 style="overflow-wrap: anywhere">
                          {{ product.seoDescription }}
                        </h6>
                      </div>
                    </div>
                    <!--- serp Mobile --->
                    <div
                      class="serp-preview d-lg-none p-3 d-flex flex-column align-items-start"
                    >
                      <div class="serp-title">
                        <h6>
                          {{ product.seoTitle }}
                        </h6>
                      </div>
                      <div class="serp-url d-flex align-items-center flex-wrap">
                        <small>
                          {{
                            `https://ariaexport.com${
                              langs[product.languageId]
                            }/products/`
                          }}
                          <!--                <small class="serp-arrow"></small>-->
                        </small>
                        <small>{{ allCharactersToDash }}</small>
                      </div>
                      <div class="serp-description">
                        <small>
                          {{ product.seoDescription }}
                        </small>
                      </div>
                    </div>
                  </b-col>
                  <b-col v-if="product" cols="6" class="my-1">
                    <h1>Product Index Status</h1>
                    <b-form-group label="allow indexing" label-for="name">
                      <b-form-checkbox v-model="product.isIndex" switch />
                    </b-form-group>
                    <b-form-group label="allow following" label-for="name">
                      <b-form-checkbox v-model="product.isFollow" switch />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>

              <b-card>
                <b-row>
                  <b-col cols="12">
                    <b-button
                      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                      class="col-12 col-md-2"
                      variant="primary"
                      @click="addProduct"
                    >
                      Save
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </validation-observer>
          </b-media>
        </b-row>
      </b-col>
    </b-row>

    <library-image-picker
      @insertImage="insertImage"
      @insertVideo="insertVideo"
    ></library-image-picker>
  </b-overlay>
</template>

<script>
import {
  BAlert,
  BAvatar,
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BImg,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Helper from "@/libs/Helper";
import { required } from "@validations";
import {
  CategoryPropertyGroupGetBy,
  ProductCategoriesGetSubCategories,
} from "@/libs/Api/ProductCategory";
import LanguagePicker from "@/views/components/utils/LanguagePicker.vue";
import AddEditDeleteButton from "@/views/components/utils/AddEditDeleteButton.vue";
import { GetAllLangs } from "@/libs/Api/Language";
import { ShipmentGetAll } from "@/libs/Api/Shipment";
import ckEditorMain from "@/views/components/ckEditorMain.vue";
import ProductCategoryProperty from "@/views/apps/product/ProductCategoryProperty.vue";
import { ProductCreate } from "@/libs/Api/Product";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { quillEditor } from "vue-quill-editor";
import QuillToolbar from "@/views/components/utils/QuillToolbar.vue";
import LibraryImagePicker from "@/views/components/utils/LibraryImagePicker.vue";

export default {
  title: "Create product",
  data() {
    return {
      required,
      languageList: [],
      overlay: false,
      categories: [],
      shipments: [],
      CPG: [],
      product: {
        languageId: 1,
        name: null,
        productCategoryId: null,
        mainId: "",
        priceValue: null,
        discountedPriceValue: null,
        // imageFile: null,
        // videoFile: null,
        seoTitle: "",
        seoDescription: "",
        seoUrl: "",
        minOrder: "",
        subTitle: "",
        shipments: [],
        shortDescription: "",
        fullDescription: "",
        properties: [],
      },
      langs: {
        2: "/fa",
        1: "",
        3: "/ar",
        4: "/ru",
        6: "/tr",
      },
      base64ImageSrc: null,
      modalCoverPic: null,
      base64ImageSrcSidebar: null,
      base64Trailer: null,
      editorOption: {
        modules: {
          toolbar: {
            align: ["", "right", "center", "justify"],
            container: "#toolbar",
            handlers: {
              image: this.imageMethod,
              video: this.imageMethod,
            },
          },
        },
        // Some Quill options...
        theme: "snow",
      },
    };
  },
  computed: {
    allCharactersToDash: {
      get: function () {
        return this.product.seoUrl;
      },
      set: function (newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.product.seoUrl = newValue;
          // Remove all characters that are NOT number
          this.product.seoUrl = this.product.seoUrl.replace(
            /[+*!@#$%^&*()_;:~`»«,×='"|<>/?{}\/\.]/g,
            ""
          );
          this.product.seoUrl = this.product.seoUrl.replaceAll(" ", "-");
        } else if (!newValue || this.product.seoUrl === "") {
          this.product.seoUrl = null;
        }
      },
    },
  },
  async created() {
    if (this.$route.query.mainId && this.$route.query.languageId) {
      this.product.mainId = this.$route.query.mainId;
      this.product.languageId = this.$route.query.languageId;
    }
    await this.getSubCategories();
    await this.getShipments();
  },
  watch: {
    "product.languageId": function (nv, ov) {
      this.getSubCategories();
      this.getShipments();
    },
    "product.productCategoryId": function (nv, ov) {
      this.getCategoryPropertyGroup();
    },
  },
  methods: {
    async addProduct() {
      let _this = this;
      Helper.validateForm(_this, "refFormObserver", async () => {
        let formData = Helper.generateAnyFormData(_this.product);
        formData.append("imageFile", _this.$refs.refInputEl.files[0]);
        formData.append("videoFile", _this.$refs.refInputEl2.files[0]);
        formData.append(
          "SideBarImageFile",
          _this.$refs.refInputElSidebar.files[0]
        );
        // _this.overlay = true;
        let productCreate = new ProductCreate(_this);
        productCreate.setParams(formData);
        await productCreate.sendFormData(
          (content) => {
            _this.overlay = false;
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: `Operation successful`,
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.$router.push("/apps/product/list");
          },
          (error) => {
            _this.overlay = false;
            console.log(error);
          }
        );
      });
    },
    async getCategoryPropertyGroup() {
      let _this = this;
      _this.overlay = true;

      let data = {
        ProductCategoryId: _this.product.productCategoryId,
        languageId: _this.product.languageId,
      };

      let categoryPropertyGroupGetBy = new CategoryPropertyGroupGetBy(_this);
      categoryPropertyGroupGetBy.setParams(data);
      await categoryPropertyGroupGetBy.fetch(
        function (content) {
          _this.overlay = false;
          _this.CPG = content.data.data;
        },
        function (error) {
          _this.overlay = false;
          console.log(error);
        }
      );
    },
    async getSubCategories() {
      let _this = this;
      _this.overlay = true;

      let data = {
        languageId: _this.product.languageId,
      };

      let productCategoriesGetSubCategories =
        new ProductCategoriesGetSubCategories(_this);
      productCategoriesGetSubCategories.setParams(data);
      await productCategoriesGetSubCategories.fetch(
        function (content) {
          _this.overlay = false;
          _this.categories = content.data.data;
        },
        function (error) {
          _this.overlay = false;
          console.log(error);
        }
      );
    },
    async getShipments() {
      let _this = this;
      _this.overlay = true;

      let data = {
        languageId: _this.product.languageId,
      };

      let shipmentGetAll = new ShipmentGetAll(_this);
      shipmentGetAll.setParams(data);
      await shipmentGetAll.fetch(
        function (content) {
          _this.overlay = false;
          _this.shipments = content.data.data;
        },
        function (error) {
          _this.overlay = false;
          console.log(error);
        }
      );
    },
    addProperty() {
      this.product.properties.push({
        categoryPropertyId: 0,
        categoryPropertyGroupId: 0,
        value: "",
        priority: "",
        showInContent: false,
      });
    },
    generateObjectForAddEditRemoveButton(data) {
      return {
        id: data.id,
        languageId: data.languageId,
        otherLanguages: data.otherLanguages || [],
        mainId: data.mainId,
      };
    },
    async getAllLanguages() {
      try {
        let requestParams = {
          count: 100,
          pageNumber: 1,
        };
        if (this.searchCommand) {
          requestParams["searchCommand"] = this.searchCommand;
        }
        this.isLoading = true;
        let _this = this;
        let getAllLangs = new GetAllLangs(_this);

        getAllLangs.setRequestParam(requestParams);
        await getAllLangs.fetch((response) => {
          if (response.isSuccess) {
            _this.languageList = response.data.languages;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setEditorContent(content) {
      this.product.fullDescription = content;
    },
    clickOnInput(id) {
      let input = document.getElementById(id);
      input.click();
    },
    setLanguageId(language) {
      this.product.languageId = language.languageId;
    },
    setCover(e) {
      let file = e.target.files[0];
      this.base64ImageSrc = URL.createObjectURL(file);
    },
    setCoverSidebar(e) {
      let file = e.target.files[0];
      this.base64ImageSrcSidebar = URL.createObjectURL(file);
    },
    setVideo(event) {
      let file = event.target.files.item(0);
      this.base64Trailer = URL.createObjectURL(file);
    },
    imageMethod() {
      this.$bvModal.show("library-image-picker-modal");
    },
    insertImage(imageUrl) {
      this.$refs.quillEditor.quill.insertEmbed(
        this.$refs.quillEditor.quill.getSelection()?.index
          ? this.$refs.quillEditor.quill.getSelection().index
          : 1,
        "image",
        imageUrl
      );
    },
    insertVideo(videoUrl) {
      this.$refs.quillEditor.quill.insertEmbed(
        this.$refs.quillEditor.quill.getSelection()?.index
          ? this.$refs.quillEditor.quill.getSelection().index
          : 1,
        "video",
        videoUrl
      );
    },
  },
  components: {
    BFormCheckbox,
    LibraryImagePicker,
    ckEditorMain,
    AddEditDeleteButton,
    LanguagePicker,
    QuillToolbar,
    BModal,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BCardText,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BAlert,
    BTab,
    BTabs,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BMedia,
    BAvatar,
    BOverlay,
    vSelect,
    BTable,
    BPagination,
    ValidationObserver,
    ValidationProvider,
    ProductCategoryProperty,
    quillEditor,
  },
};
</script>

<style>
.modal-header > .close {
  display: none !important;
}
</style>
